/**
 * Super administrators — the only users who may see the Administration panel
 * (user management, password resets, Case Intelligence System).
 *
 * Keep this list lowercase; membership is checked case-insensitively.
 */
export const SUPER_ADMINS: readonly string[] = [
  'david.planes@lexidy.com',
  'geronimo.mccluskey@lexidy.com',
  /* hernan.vergara@lexidy.com: no longer a super admin (Gerónimo, 23 Sept
     2026) — a regular account that sees its own country. */
];

/** True when the given email belongs to a super administrator. */
export function isSuperAdmin(email: string | null | undefined): boolean {
  if (!email) return false;
  return SUPER_ADMINS.includes(email.trim().toLowerCase());
}
